// app/javascript/controllers/hr_portal/program_information_controller.js
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel', 'untilLanding']
  static values = { activeProgramId: String }

  connect() {
    if (!this.hasActiveProgramIdValue && this.tabTargets.length > 0) {
      this.activeProgramIdValue = this.programIdFromTab(this.tabTargets[0])
    } else {
      this.updateView()
    }
  }

  select(event) {
    event.preventDefault()

    const programId =
      event.params.programId || this.programIdFromTab(event.currentTarget)

    this.activeProgramIdValue = programId

    // Smooth scroll on small screens after DOM updates
    if (window.matchMedia('(max-width: 640px)').matches) {
      requestAnimationFrame(() => {
        const panel = this.panelTargets.find(
          (p) => p.dataset.programId === this.activeProgramIdValue,
        )
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }
  }

  activeProgramIdValueChanged() {
    this.updateView()
  }

  updateView() {
    let activeTab = null

    this.tabTargets.forEach((tab) => {
      const isActive = this.programIdFromTab(tab) === this.activeProgramIdValue
      tab.dataset.active = isActive
      if (isActive) activeTab = tab
    })

    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.programId === this.activeProgramIdValue
      panel.classList.toggle('hidden', !isActive)
    })

    if (this.hasUntilLandingTarget) {
      const show = activeTab?.dataset.showUntilLandingParam === 'true'
      this.untilLandingTarget.classList.toggle('hidden', !show)
    }
  }

  programIdFromTab(tab) {
    return tab.dataset.hrPortalProgramInformationProgramIdParam
  }
}
